import FileSelect from '../../../elements/FileSelect'
import useFetchSelect from '../../../elements/Hooks/useFetchSelect'
import MultiCurrency from '../../../elements/MultiCurrency'

import FormSectionTitle from '../../../elements/FormSectionTitle'
import withSort from '../../../elements/HOC/withSort'
import withSpinning from '../../../elements/HOC/withSpinning'
import RegisteredPartnerDetails from '../../../elements/RegisteredPartnerDetails'
import CountrySelect from '../../../elements/Select/Country'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules, threeFormItemLayout } from '../../../modules/FormItems'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Col, DatePicker, Descriptions, Form, Input, InputNumber, Row, TimePicker } from 'antd'
import _, { get, isEmpty } from 'lodash'
import { dateVal, strVal } from '../../../modules/Utils'

import { compose } from 'recompose'
import EmployeesSelect from '../../../elements/Select/Employee/EmployeesSelect'
import Authentication from '../../../modules/Authentication'
import useFetchObject from '../../../elements/Hooks/useFetchObject'
import SalesContractsApi from '../../../api/Sales/SalesContracts'
import { ProductTypeSelect } from '../../../components/Sales/Quotes/AddQuote/QuoteForm'
import IconText from '../../../elements/IconText'
import InfoTooltip from '../../../elements/InfoTooltip'
import DeliveryDetails from '../../../elements/DeliveryDetails'
import { AddEnquiryContext } from '../Enquiries/AddEnquiry/AddEnquiriesCont'
import { GlobalContext } from 'Global'
import Taxes from '../../../elements/Taxes'

const { TextArea } = Input
const auth = new Authentication()

const MethodSelect = compose(
  withSelectFetch({
    dropdown: 'enquiry',
    name: 'method',
  }),
  withSpinning,
  withSort
)(CustomSelect)
const TimezoneSelect = compose(
  withSelectFetch({
    dropdown: 'general',
    name: 'timezones',
  }),
  withSpinning,
  withSort
)(CustomSelect)

const ResponseTypeSelect = compose(
  withSelectFetch({
    dropdown: 'enquiry',
    name: 'response',
  }),
  withSpinning,
  withSort
)(CustomSelect)

const PriorityTypeSelect = compose(
  withSelectFetch({
    dropdown: 'enquiry',
    name: 'priority',
  }),
  withSpinning,
  withSort
)(CustomSelect)

const TypeSelect = compose(
  withSelectFetch({
    dropdown: 'quotes',
    name: 'type',
  }),
  withSpinning,
  withSort
)(CustomSelect)

const salesContractsApi = new SalesContractsApi()

function EnquiriesForm(props) {
  const { getFieldDecorator, resetFields, getFieldValue, setFieldsValue } = props.form

  const { enquiry, onChangeEnquirer, setContactPersonLoading, fetching } = React.useContext(AddEnquiryContext)

  const contractID = getFieldValue('contract._id') || get(enquiry, 'contract._id', '')

  const [enquiryLocation, setEnquiryLocation] = useState({})

  const { tenantOptions, member } = React.useContext(GlobalContext)

  /*useEffect(() => {
    if (getFieldValue('enquiryType')) {
      ['MRO'].includes(getFieldValue('enquiryType')) ?
      props.form.setFieldsValue({ 'location': 'Hong Kong, SAR of China' }) :
        ['Fencing','Steel'].includes(getFieldValue('enquiryType')) ?
          props.form.setFieldsValue({ 'location': 'Papua New Guinea' }) :
          ['Maintenance','Works'].includes(getFieldValue('enquiryType')) ?
            props.form.setFieldsValue({ 'location': 'Malaysia' }) :
            ['Agent Sales','Fogging','Online Sales','Stocked Products'].includes(getFieldValue('enquiryType')) ?
          props.form.setFieldsValue({ 'location': 'United Kingdom' })
          : props.form.setFieldsValue({ 'location': '' })
    }
  }, [getFieldValue('enquiryType')])*/

  useEffect(() => {
    if (getFieldValue('enquirer._id')) {
      onChangeEnquirer(getFieldValue('enquirer._id'))
      props.form.setFieldsValue({
        'enquirer_rep._id': get(enquiry, 'enquirer_rep._id') || member,
      })
    } else {
      setContactPersonLoading(false)
    }
  }, [])
  const isExistingContract = getFieldValue('isExistingContract') || get(enquiry, 'isExistingContract', false)
  const contractKey = contractID.replace('salesContracts/', '')
  const { object: contract } = useFetchObject(
    () => salesContractsApi.get(contractKey),
    false,
    [contractKey],
    isEmpty(contractKey)
  )
  useEffect(() => {
    if (!isEmpty(contract))
      setFieldsValue({
        centers: get(contract, 'budget.cost._id'),
      })
  }, [contract._rev])

  const [showDesc, setShowDesc] = React.useState(() => !isEmpty(enquiry.description))

  const responseType = getFieldValue('responseType') || get(enquiry, 'responseType', '')
  const isResponseTypeSalesConfirmation = ['Sales Confirmation', 'Phone Sales'].includes(responseType)
  const isResponseTypeProductQuote = responseType === 'Product Quotation'

  const company = (getFieldValue('company._id') || get(enquiry, 'company._id') || '').replace('members/', '')

  const { SelectData: LogisticContractSelect, data: logisticContracts = [] } = useFetchSelect({
    url: `/purchaseContracts/company/${company}?type=logistics`,
    dependencyArray: [company],
    dontFetch: isEmpty(company),
    mapFunction: (i) => ({
      ...i,
      display: `${i.default ? '[Default]' : ''} ${i.title} - ${i.owner.fn}`,
    }),
  })
  //console.log("logistics:",logisticContracts)

  useEffect(() => {
    if (
      logisticContracts &&
      (get(enquiry, 'company._id') !== getFieldValue('company._id') || !getFieldValue('logistic._id'))
    ) {
      const defaultContract = logisticContracts.find((i) => i.default)
      //setFieldsValue({ 'logistic._id': 'purchaseContracts/10334045587600' })
      if (defaultContract?._id) {
        setFieldsValue({ 'logistic._id': defaultContract._id })
      }
    }
  }, [logisticContracts.length, company, getFieldValue('company._id')])

  //Phone Sales

  return (
    <Form>
      {/* ENQUIRY DETAILS */}
      <FormSectionTitle title={'ENQUIRY DETAILS'} />

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Title'}>
            {getFieldDecorator('title', {
              initialValue: get(enquiry, 'title'),
              rules: rules.input,
            })(<Input placeholder={'Title'} />)}
            <IconText
              text={
                showDesc !== true ? 'Optionally Add Enquiry Summary Description' : 'Remove Enquiry Summary Description'
              }
              type={showDesc !== true ? 'plus-circle' : 'minus-circle'}
              onClick={() => setShowDesc(!showDesc)}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            {...defaultFormItemLayout}
            label={<InfoTooltip value={'Reference No'} title={'Client Enquiry Reference No'} />}>
            {getFieldDecorator('reference.no', {
              initialValue: get(enquiry, 'reference.no'),
            })(<Input placeholder={'Client Ref.'} />)}
          </Form.Item>
        </Col>
      </Row>
      {showDesc === true && (
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label={'Summary'}>
              {getFieldDecorator('description', {
                initialValue: get(enquiry, 'description'),
                rules: rules.input,
              })(<TextArea placeholder={'Enquiry Summary'} />)}
            </Form.Item>
          </Col>
        </Row>
      )}
      <Row>
        <Col span={12}>
          <Form.Item
            {...defaultFormItemLayout}
            label={<InfoTooltip value={'Date Received'} title={'Date Enquiry Received'} />}>
            {getFieldDecorator('date', {
              initialValue: dateVal(enquiry, 'date') || moment(),
              rules: rules.select,
            })(<DatePicker style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Method">
            {getFieldDecorator('enquiryMethod', {
              initialValue: get(enquiry, 'enquiryMethod') || get(tenantOptions, 'enquiry.method'),
              rules: rules.select,
            })(
              <MethodSelect placeholder="Select a Method" keyAtr={'key'} valueAtr={'value'} style={{ width: '100%' }} />
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Enquiry For'}>
            {getFieldDecorator('enquiryType', {
              initialValue: get(enquiry, 'enquiryType') || get(tenantOptions, 'enquiry.enquiryType'),
              rules: rules.select,
            })(<ProductTypeSelect />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            {...defaultFormItemLayout}
            label={<InfoTooltip value={'Location'} title={'Location of Delivery / Service'} />}>
            {getFieldDecorator('location', {
              initialValue: get(enquiry, 'location') || get(tenantOptions, 'enquiry.location'),
            })(<CountrySelect setSelected={setEnquiryLocation} />)}
          </Form.Item>
        </Col>
      </Row>

      {/* CLIENT DETAILS */}
      <FormSectionTitle title={'CLIENT DETAILS'} />
      {get(enquiry, 'enquiryDetails') && (
        <Row>
          <Descriptions title="Online Enquiry Info" bordered>
            <Descriptions.Item label="Company Name">{get(enquiry, 'enquiryDetails.companyName')}</Descriptions.Item>
            <Descriptions.Item label="Contact Name">{get(enquiry, 'enquiryDetails.contactName')}</Descriptions.Item>
            <Descriptions.Item label="Email">{get(enquiry, 'enquiryDetails.email')}</Descriptions.Item>
            <Descriptions.Item label="Phone">{get(enquiry, 'enquiryDetails.phone')}</Descriptions.Item>
            <Descriptions.Item label="Country">{get(enquiry, 'enquiryDetails.country')}</Descriptions.Item>
            <Descriptions.Item label="is First Responder">
              {get(enquiry, 'enquiryDetails.isFirstResponder') ? 'Yes' : 'No'}
            </Descriptions.Item>
            <Descriptions.Item label="Note">{get(enquiry, 'enquiryDetails.note')}</Descriptions.Item>
          </Descriptions>
        </Row>
      )}
      <Row>
        <RegisteredPartnerDetails
          doc={enquiry}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            defaultCompany: get(tenantOptions, 'enquiry.company._id'),
            type: 'enquiry',
            showProfit: !getFieldValue('isExistingClient'),
            showRepEmail: true,
          }}
        />
      </Row>
      {/*<Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Profit Center">
            {getFieldDecorator('centers', {
              initialValue: get(enquiry, 'centers'),
              rules: rules.select,
            })(
              <CentersCascader
                key={
                  getFieldValue('company._id') || get(contract, 'company._id')
                }
                category={'Profit'}
                company={
                  getFieldValue('company._id') || get(contract, 'company._id')
                }
                placeholder="Select a Division"
                keyAtr={'key'}
                valueAtr={'value'}
                style={{width: '100%'}}
              />,
            )}
          </Form.Item>
        </Col>
      </Row>*/}
      {/* RESPONSE DUE */}
      <FormSectionTitle title={'RESPONSE DETAILS'} />
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Response Type">
            {getFieldDecorator('responseType', {
              initialValue: get(enquiry, 'responseType') || get(tenantOptions, 'enquiry.responseType'),
              rules: rules.select,
            })(<ResponseTypeSelect style={{ width: '100%' }} />)}
          </Form.Item>
          <Form.Item {...defaultFormItemLayout} label="Priority">
            {getFieldDecorator('priority', {
              initialValue: get(enquiry, 'priority') || get(tenantOptions, 'enquiry.priority'),
              rules: rules.select,
            })(<PriorityTypeSelect />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Response Due">
            {getFieldDecorator('due', {
              initialValue: dateVal(enquiry, 'due') || moment().add(get(tenantOptions, 'enquiry.responseLag'), 'd'),
              rules: rules.select,
            })(
              <DatePicker
                style={{ width: '100%' }}
                onChange={(value) => {
                  if (value) {
                    const newV = moment(value.format()).subtract(3, 'days')
                    setFieldsValue({ followupDate: newV })
                  }
                }}
              />
            )}
            {getFieldDecorator('dueTime', {
              initialValue: dateVal(enquiry, 'dueTime'),
            })(<TimePicker defaultOpenValue={moment('00:00:00', 'HH:mm:ss')} />)}
            {getFieldDecorator('dueTimezone', {
              initialValue: get(enquiry, 'dueTimezone'),
            })(<TimezoneSelect placeholder={'Select a timezone'} keyAtr={'text'} valueAtr={'text'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Assigned To">
            {getFieldDecorator('assignedTo._id', {
              initialValue: get(enquiry, 'assignedTo._id') || get(member, '_id'),
              rules: rules.select,
            })(<EmployeesSelect />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Follow-up Date">
            {getFieldDecorator('followupDate', {
              initialValue:
                dateVal(enquiry, 'followupDate') || moment().add(get(tenantOptions, 'enquiry.followUpLag'), 'd'),
            })(<DatePicker style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>
      {isResponseTypeProductQuote && (
        <>
          <FormSectionTitle title={'QUOTATION DETAILS'} />
          <Row>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Type'}>
                {getFieldDecorator('quote.type', {
                  initialValue: get(enquiry, 'quote.type') || get(tenantOptions, 'enquiry.quoteType'),
                  rules: [
                    {
                      required: true,
                      message: 'Please Select a Type!',
                    },
                  ],
                })(<TypeSelect style={{ width: '80%' }} placeholder={'Type'} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Valid till'}>
                {getFieldDecorator('quote.validity.date', {
                  initialValue:
                    dateVal(enquiry, 'quote.validity.date') ||
                    moment().add(get(tenantOptions, 'enquiry.quoteValidity'), 'd'),
                  rules: [{ required: true, message: 'Please Select a date!' }],
                })(
                  <DatePicker
                    style={{
                      width: getFieldValue('validity.date') ? '80%' : '100%',
                    }}
                    disabledDate={disabledDate}
                    placeholder={'Valid till'}
                  />
                )}
                {getFieldValue('quote.validity.date') && (
                  <span style={{ marginLeft: 15, color: 'darkred' }}>
                    {getFieldValue('quote.validity.date').diff(
                      getFieldValue('date') ? getFieldValue('date') : moment(),
                      'd'
                    ) + 1}{' '}
                    Days
                  </span>
                )}
              </Form.Item>
            </Col>
            <Taxes
              doc={enquiry}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                resetFields,
                type: 'quote',
                hideRate: true,
              }}
            />
          </Row>
        </>
      )}

      {isResponseTypeSalesConfirmation && (
        <>
          <FormSectionTitle title={'CLIENT PURCHASE ORDER DETAILS (CPO)'} />
          <Row>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'CPO Date'}>
                {getFieldDecorator('cpo.date', {
                  initialValue: dateVal(enquiry, 'cpo.date'),
                  rules: [
                    {
                      required: true,
                      message: 'Please Select a Date!',
                    },
                  ],
                })(<DatePicker style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'CPO No.'}>
                {getFieldDecorator('cpo.no', {
                  initialValue: strVal(enquiry, 'cpo.no'),
                  rules: [
                    {
                      required: true,
                      message: 'Please Input CPO Number!',
                    },
                  ],
                })(<Input placeholder={'Client Purchase Order No.'} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'Reference No.'}>
                {getFieldDecorator('reference.no', {
                  initialValue: get(enquiry, 'reference.no'),
                })(<Input placeholder={'Client Reference No.'} disabled={get(enquiry, 'isOnlineOrder', false)} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <MultiCurrency
              doc={enquiry}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                type: 'enquiry',
              }}
            />
            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label={'Invoicing Date'}>
                {getFieldDecorator('cpo.invoiceDate', {
                  initialValue: dateVal(enquiry, 'cpo.invoiceDate'),
                  /*rules: [
                    {
                      required: true,
                      message: 'Please Select a Date!',
                    },
                  ],*/
                })(<DatePicker style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label={'Amount'}>
                {getFieldDecorator('cpo.amount', {
                  initialValue: get(enquiry, 'cpo.amount'),
                })(<InputNumber placeholder={'CPO Amount'} style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>

            <FileSelect
              {...{
                doc: enquiry,
                getFieldValue,
                getFieldDecorator,
                acc: 'cpo.file',
                label: 'CPO File',
              }}
            />
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label="Logistic Contract">
                {getFieldDecorator('logistic._id', {
                  initialValue: strVal(enquiry, 'logistic._id'),
                  //rules: rules.select
                })(<LogisticContractSelect keyAtr={'_id'} valueAtr="display" />)}
              </Form.Item>
            </Col>
          </Row>
        </>
      )}

      {/* DELIVERY DETAILS */}
      <Row>
        <DeliveryDetails
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            doc: enquiry,
            showNotify: isResponseTypeSalesConfirmation,
            type: 'Enquiry',
            subType: responseType,
            listId: get(contract, '_id'),
          }}
        />
      </Row>
    </Form>
  )
}

function disabledDate(current) {
  // Can not select days before today and today
  return current && current < moment().endOf('day')
}

EnquiriesForm.propTypes = {}
EnquiriesForm.defaultProps = { type: 'new' }

export default Form.create()(EnquiriesForm)
